// All entries where county_id is "simcoe"
const simcoeLakes = lakes.filter(lake => lake.county_id === "simcoe");

// All entries where county_id is "haliburton" and is active
const haliburtonLakesActive = lakes.filter(lake => lake.county_id === "haliburton" && lake.active === true);

// All entries where county_id is "haliburton" and is active
const kawarthalakesLakesActive = lakes.filter(lake => lake.county_id === "kawarthalakes" && lake.active === true);

// All entries where active is true
const activeLakes = lakes.filter(lake => lake.active === true);

// All entries where designed is true
const designedLakes = lakes.filter(lake => lake.designed === true);

// Create a lookup object for faster access to areas
const areasLookup = {};
areas.forEach(area => {
  areasLookup[area.id] = area;
});

// Merge the data
const lakeswithAreas = lakes.map(lake => {
  const area = areasLookup[lake.county_id];
  return { ...lake, area: area || null }; // Merge lake with area, or null if no match
});

const lakespopularwithAreas = lakesPopular.map(lake => {
  const area = areasLookup[lake.county_id];
  return { ...lake, area: area || null }; // Merge lake with area, or null if no match
});

const lakesactivewithAreas = activeLakes.map(lake => {
  const area = areasLookup[lake.county_id];
  return { ...lake, area: area || null }; // Merge lake with area, or null if no match
});

// Use .map() to create a *new* array with the lake counts added.
// This is generally preferred to modifying the original array in place.

const areasWithLakeCounts = areas
  .map(function(area) {
    var lakeCount = lakes.filter(function(lake) {
      return lake.county_id === area.id && lake.active === true;
    }).length;

    return $.extend({}, area, { lake_count: lakeCount }); // jQuery 1.9.1 compatible way
  })
  .sort(function(a, b) {
    return a.name.localeCompare(b.name); // Sort alphabetically by name
  });


function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

function shuffleArrayAlt(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 2));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

var popularLakesWithAreas = [];
var popularLakesWithAreasAlt = [];

$.each(lakesPopular, function(index, popularLake) {
  var match = $.grep(lakeswithAreas, function(lake) {
    return lake.id === popularLake.id && lake.county_id === popularLake.county_id;
  });

  if (match.length > 0) {
    popularLakesWithAreas.push(match[0]);
  }
});

$.each(lakesPopular, function(index, popularLake) {
  var match = $.grep(lakeswithAreas, function(lake) {
    return lake.id === popularLake.id && lake.county_id === popularLake.county_id;
  });

  if (match.length > 0) {
    popularLakesWithAreasAlt.push(match[0]);
  }
});

shuffleArray(popularLakesWithAreas);
shuffleArray(popularLakesWithAreasAlt);
